<template>
  <v-card tile>
    <v-card-title class="py-2" @click="show = !show" style="cursor: pointer;">
      <h3>{{instance.title}}</h3>
      <v-spacer></v-spacer>
      <v-btn icon>
        <v-icon>{{ show ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text v-show="show && !is_empty">
      <h3>Relays</h3>
      <v-layout>
        <v-flex xs6 font-weight-bold class="py-2">Relay</v-flex>
        <v-flex xs6 font-weight-bold class="py-2"></v-flex>
      </v-layout>
      <template v-for="relay in relays">
        <v-divider></v-divider>
        <v-layout>
          <v-flex xs6 class="py-2" style="vertical-align: middle;">{{relay.name}}</v-flex>
          <v-flex xs6 class="py-2" style="text-align: right;">
            <v-btn :color="relay.state ? 'red' : 'green'" small icon flat><v-icon>circle</v-icon></v-btn>
            <v-btn color="warning" small @click="reset_device(relay.device)" :loading="loading_button(relay)" :disabled="loading_button(relay)">Reset</v-btn>
          </v-flex>
        </v-layout>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import InstanceModel from '@/models/instance.js'

export default {
  props: ['id'],
  data () {
    var ch = this.$cloudserver.channel("instances:status:"+this.id);
    return {
      show: false,
      ws_channel: ch,
      loading_buttons: {}
    }
  },
  created() {
    this.ws_channel.join();
  },
  computed: {
    instance () {
      return InstanceModel.instance_by_id(this.id);
    },
    relay_states () {
      return _.get(this.ws_channel.data, "instance.relays", []);
    },
    relays() {
      return _.map(this.relay_states, (state, device) => {
        return {state: state, device: device+1, name: _.get(this.instance, ["meta", "relay_names", device], "Unused")}
      })
    },
    is_empty() {
      return _.isEmpty(this.relays);
    }
  },
  methods: {
    loading_button(relay) {
      return this.loading_buttons[relay.device] || relay.state;
    },
    reset_device(device) {
      this.loading_buttons[device] = true;
      this.$nextTick(() => {
        InstanceModel.send_command_to_external_device(this.instance, "reset-device", {device: device}, () => {}, () => {});
        setTimeout(() => {
          this.loading_buttons[device] = false;
        }, 5000);
      });

    }
  }
}
</script>
